var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-badge',{attrs:{"hidden":!_vm.qty,"value":_vm.qty}},[_c('van-image',{attrs:{"src":_vm.src,"lazy-load":"","width":"100%","show-error":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }